import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  text: {
    fontFamily: "Poppins",
    fontWeight: "bold",
  },
}));

export default useStyles;
